import escapeHtml from "lodash/escape";

export function subTranslationVars(
  template: string,
  vars: Record<string, string>,
  options: { escapeHtml: boolean } = { escapeHtml: false },
): string {
  return Object.entries(vars).reduce(
    (result, [key, value]) =>
      result.replace(
        `{${key}}`,
        options.escapeHtml ? escapeHtml(value) : value,
      ),
    template,
  );
}
